import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Notebox(props) {
    return (
        <div className="p-100 pb-0">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="boxes_item text-center">
                            <Row>
                                <Col xs={12} md={10} lg={8} xl={8} xxl={8} className="m-auto">
                                    <h2>Why Do Businesses Prefer Custom HRM Software?</h2>
                                    <p>Around <strong>55%</strong> of corporate enterprises prefer using custom HRM
                                        software tailored to their business needs to manage their organizational tasks
                                        more effectively.</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Notebox;